import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import payoutService from 'api/payoutService';

export const useAllPayouts = (params) => {
    return useQuery({
        queryKey: ['allPayouts', params],
        queryFn: () => payoutService.adminGetAllPayouts(params)
    });
};

export const useCompletePayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => payoutService.adminCompletePayout(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['allPayouts'] });
        }
    });
};

export const useRejectPayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, reason }) => payoutService.adminRejectPayout(id, reason),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['allPayouts'] });
        }
    });
};

export const useRequestPayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => payoutService.vendorRequestPayout(payload),
        onSuccess: () => {
            // Refresh wallet balance and transactions immediately after request
            queryClient.invalidateQueries({ queryKey: ['vendorWallet'] });
            queryClient.invalidateQueries({ queryKey: ['allPayouts'] });
            queryClient.invalidateQueries({ queryKey: ['allVendorPayouts'] });
        }
    });
};

export const useAdminRequestPayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => payoutService.adminRequestPayout(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vendorsWallet'] });
            queryClient.invalidateQueries({ queryKey: ['allPayouts'] });
            queryClient.invalidateQueries({ queryKey: ['systemWallet'] });
        }
    });
};

export const useAllVendorPayouts = (params) => {
    return useQuery({
        queryKey: ['allVendorPayouts', params],
        queryFn: () => payoutService.getVendorPayouts(params)
    });
};
